import { createContext } from "react";

const AuthenContext = createContext({});

export default AuthenContext;